import axiosInstance from "../../api";

import { Dispatch } from "redux";
import * as UiTypes from "../types/ui.types";

import {
  LOADING_EVENT_SUCCESS,
  LOADING_EVENT_START,
  LOAD_EVENTS,
  SAVE_SUCCESS,
  LOAD_FACILITIES,
  LOAD_WORK_TYPES,
  LOAD_EMPLOYEES,
  LOAD_WORKTYPE_EMPLOYEES,
  LOAD_LATEST_SELECTED_EVENT_DATA,
  DELETE_EVENT,
  PATCH_EDITED_EVENT,
} from "../types/schedule.types";

import { workType } from "../reducers/schedule.reducer";
import { alertActions } from "./alert.actions";

export type filterEventsType = {
  start_date: String;
  end_date: String;
  employee?: String[];
  facility?: string;
  work_type?: string[];
};

export const loadEvents =
  (filterEvents: filterEventsType) => (dispatch: Dispatch) => {
    if (filterEvents) {
      dispatch({ type: LOADING_EVENT_START });

      axiosInstance
        .get("schedule/", {
          params: filterEvents,
        })
        .then((response: any) => {
          dispatch({ type: LOAD_EVENTS, payload: response.data.data });
        })
        .catch((err: any) => {
          // dispatch({ type: SET_ERROR, payload: err.response.message });
          if (err?.response?.status === 0) {
            dispatch(alertActions.error("Network error"));
          } else if (err?.response?.message) {
            dispatch(alertActions.error(err.response.message.toString()));
          } else if (err?.message)
            dispatch(alertActions.error(err.message.toString()));
          else {
            dispatch(alertActions.error("Failed to load schedules"));
          }
        })
        .finally(() => {
          dispatch({ type: LOADING_EVENT_SUCCESS });
        });
    }
  };

export const loadScheduleFacilities = () => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_EVENT_START });
  axiosInstance
    .get("schedule/facilities")
    .then((response: any) => {
      dispatch({ type: LOAD_FACILITIES, payload: response.data.data });
    })
    .catch((err: any) => {
      dispatch(alertActions.showError(err, "Failed to load facilities"));
    });
};

export const addNewEvent =
  (formData: any, filterEvents: any) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_EVENT_START });
    dispatch({ type: UiTypes.LOADING_UI });

    axiosInstance
      .post(`schedule/`, formData, { params: filterEvents })
      .then((res: any) => {
        dispatch({ type: SAVE_SUCCESS });
        dispatch(alertActions.success("Schedule has been added successfully"));
        //load datas
        dispatch({ type: LOAD_EVENTS, payload: res?.data?.data });
      })
      .catch((err: any) => {
        // dispatch({ type: SET_ERROR, payload: err?.response?.message ? `${err.response.message}` : "Error while posting event" });
        if (err?.response?.status === 0) {
          dispatch(alertActions.error("Network error"));
        } else if (err?.response?.data?.message) {
          dispatch(alertActions.error(err.response.data.message.toString()));
        } else if (err?.response?.message) {
          dispatch(alertActions.error(err.response.message.toString()));
        } else if (err?.message)
          dispatch(alertActions.error(err.message.toString()));
        else {
          dispatch(alertActions.error("Failed to add new event"));
        }
        dispatch({ type: LOADING_EVENT_SUCCESS });
      })
      .finally(() => {
        dispatch({ type: LOADING_EVENT_SUCCESS });
      });
  };

export const loadSingleEvent = (id: string) => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_EVENT_START });

  axiosInstance
    .get(`schedule/${id}`)
    .then((response: any) => {
      dispatch({
        type: LOAD_LATEST_SELECTED_EVENT_DATA,
        payload: response.data.data,
      });
      dispatch({ type: PATCH_EDITED_EVENT, payload: response?.data?.data });
    })
    .catch((err: any) => {
      // dispatch({ type: SET_ERROR, payload: err.response.message });
      if (err?.response?.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message.toString()));
      } else if (err?.message)
        dispatch(alertActions.error(err.message.toString()));
      else {
        dispatch(alertActions.error("Failed to load schedules"));
      }
    })
    .finally(() => {
      dispatch({ type: LOADING_EVENT_SUCCESS });
    });
};

export const editEvent =
  (id: string, formData: any) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_EVENT_START });

    axiosInstance
      .put(`schedule/${id}`, formData)
      .then((res: any) => {
        dispatch({ type: SAVE_SUCCESS });

        dispatch(alertActions.success("Schedule has been edited successfully"));

        dispatch({ type: PATCH_EDITED_EVENT, payload: res?.data?.data });
      })
      .catch((err: any) => {
        if (err?.response?.status === 0) {
          dispatch(alertActions.error("Network error"));
        } else if (err?.response?.data?.message) {
          dispatch(alertActions.error(err.response.data.message.toString()));
        } else if (err?.response?.message) {
          dispatch(alertActions.error(err.response.message.toString()));
        } else if (err?.message)
          dispatch(alertActions.error(err.message.toString()));
        else {
          dispatch(alertActions.error("Failed to edit event"));
        }
      })
      .finally(() => {
        dispatch({ type: LOADING_EVENT_SUCCESS });
      });
  };

export const deleteEvent = (id: string) => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_EVENT_START });

  axiosInstance
    .delete(`schedule/${id}`)
    .then((res: any) => {
      dispatch({ type: SAVE_SUCCESS });
      dispatch({ type: DELETE_EVENT, payload: id });
      dispatch(alertActions.success("Schedule has been deleted successfully"));
      dispatch({ type: LOAD_LATEST_SELECTED_EVENT_DATA, payload: null });
    })
    .catch((err: any) => {
      if (err?.response?.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.data?.message) {
        dispatch(alertActions.error(err.response.data.message.toString()));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message.toString()));
      } else if (err?.message)
        dispatch(alertActions.error(err.message.toString()));
      else {
        dispatch(alertActions.error("Failed to delete event"));
      }
    })
    .finally(() => {
      dispatch({ type: LOADING_EVENT_SUCCESS });
    });
};

export const addWorktype = (worktype: string) => (dispatch: Dispatch) => {
  dispatch({ type: LOADING_EVENT_START });
  axiosInstance
    .post(`schedule/worktype`, { work_type: worktype })
    .then((res: any) => {
      dispatch({ type: SAVE_SUCCESS });
      dispatch(alertActions.success("Worktype has been added successfully"));
    })
    .catch((err: any) => {
      if (err?.response?.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.data?.message) {
        dispatch(alertActions.error(err.response.data.message.toString()));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message.toString()));
      } else if (err?.message)
        dispatch(alertActions.error(err.message.toString()));
      else {
        dispatch(alertActions.error("Failed to add worktype"));
      }
    })
    .finally(() => {
      dispatch({ type: LOADING_EVENT_SUCCESS });
    });
};

export const loadWorkTypes = () => (dispatch: Dispatch) => {
  axiosInstance
    .get("schedule/worktype")
    .then((response) => {
      dispatch({
        type: LOAD_WORK_TYPES,
        payload: response.data.data.map(({ id, work_type }: workType) => {
          return { id, name: work_type };
        }),
      });
    })
    .catch((err) => {
      if (err?.response?.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.data?.message) {
        dispatch(alertActions.error(err.response.data.message.toString()));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message.toString()));
      } else if (err?.message)
        dispatch(alertActions.error(err.message.toString()));
      else {
        dispatch(alertActions.error("Failed to load worktypes"));
      }
    });
};

export const checkWorkLimit =
  (event_id: string, employee_id: string) => (dispatch: Dispatch) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: LOADING_EVENT_START });
    if (employee_id) {
      // if employee is to be set
      axiosInstance
        .get(`schedule/check-work-limit/${employee_id}/${event_id}`)
        .then((res: any) => {
          if (res?.data?.data?.user_working_limit) {
            dispatch<any>(assignEmployee(event_id, employee_id));
          }
        })
        .catch((err: any) => {
          dispatch(alertActions.showError(err, "Work limit error"));
          dispatch({ type: LOADING_EVENT_SUCCESS });
        });
    } else {
      // if employee is to be set null
      dispatch<any>(unAssignEmployee(event_id));
    }
  };

export const unAssignEmployee = (event_id: string) => (dispatch: Dispatch) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: LOADING_EVENT_START });

  axiosInstance
    .patch(`schedule/disallocate/${event_id}`)
    .then((res: any) => {
      dispatch({ type: SAVE_SUCCESS });
      dispatch(alertActions.success("Employee unassigned successfully"));
      dispatch({ type: PATCH_EDITED_EVENT, payload: res?.data?.data });
    })
    .catch((err: any) => {
      if (err?.response?.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else if (err?.response?.data?.message) {
        dispatch(alertActions.error(err.response.data.message.toString()));
      } else if (err?.response?.message) {
        dispatch(alertActions.error(err.response.message.toString()));
      } else if (err?.message)
        dispatch(alertActions.error(err.message.toString()));
      else {
        dispatch(alertActions.error("Failed to assign employees"));
      }
      dispatch({ type: LOADING_EVENT_SUCCESS });
    })
    .finally(() => {
      dispatch({ type: LOADING_EVENT_SUCCESS });
    });
};

export const assignEmployee =
  (event_id: string, employee_id: string) => (dispatch: Dispatch) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: LOADING_EVENT_START });

    axiosInstance
      .patch(`schedule/assign/${event_id}`, { employee: employee_id })
      .then((res: any) => {
        dispatch({ type: SAVE_SUCCESS });
        dispatch(
          alertActions.success("Employee has been assigned successfully")
        );
        dispatch({ type: PATCH_EDITED_EVENT, payload: res?.data?.data });
      })
      .catch((err: any) => {
        if (err?.response?.status === 0) {
          dispatch(alertActions.error("Network error"));
        } else if (err?.response?.data?.message) {
          dispatch(alertActions.error(err.response.data.message.toString()));
        } else if (err?.response?.message) {
          dispatch(alertActions.error(err.response.message.toString()));
        } else if (err?.message)
          dispatch(alertActions.error(err.message.toString()));
        else {
          dispatch(alertActions.error("Failed to assign employees"));
        }
        dispatch({ type: LOADING_EVENT_SUCCESS });
      })
      .finally(() => {
        dispatch({ type: LOADING_EVENT_SUCCESS });
      });
  };

export const loadEmployees = () => (dispatch: Dispatch) => {
  axiosInstance
    .get("schedule/employees")
    .then((response) => {
      dispatch({
        type: LOAD_EMPLOYEES,
        payload: response?.data?.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch(alertActions.error("Network error"));
      } else {
        dispatch(alertActions.error("Error while loading employees list"));
      }
    });
};
export const loadWorktypeEmployee =
  (worktype_id: string) => (dispatch: Dispatch) => {
    axiosInstance
      .get(`schedule/employees/${worktype_id}`)
      .then((response) => {
        dispatch({
          type: LOAD_WORKTYPE_EMPLOYEES,
          payload: response?.data?.data,
        });
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch(alertActions.error("Network error"));
        } else {
          dispatch(alertActions.error("Error while loading employees list"));
        }
      });
  };
